import { batch } from 'react-redux';

import { handleErrors } from './ErrorActions';
import * as taskStatusApi from '../api/task-status';

export const TASK_STATUS_PANEL_GET_TASK_STATUS = 'TASK_STATUS_PANEL_GET_TASK_STATUS';
export const TASK_STATUS_PANEL_GET_TASK_STATUS_SUCCESS =
  'TASK_STATUS_PANEL_GET_TASK_STATUS_SUCCESS';
export const TASK_STATUS_PANEL_GET_TASK_STATUS_FAILURE =
  'TASK_STATUS_PANEL_GET_TASK_STATUS_FAILURE';

export const getTaskStatusSuccess = (taskStatus) => ({
  type: TASK_STATUS_PANEL_GET_TASK_STATUS_SUCCESS,
  payload: {
    taskStatus,
  },
});

export const getTaskStatusFailure = (error) => ({
  type: TASK_STATUS_PANEL_GET_TASK_STATUS_FAILURE,
  payload: {
    error,
  },
});

export const getTaskStatus = (itmId, entityName) => async (dispatch) => {
  dispatch({
    type: TASK_STATUS_PANEL_GET_TASK_STATUS,
  });

  try {
    const apiData = await taskStatusApi.getTaskStatus(itmId, entityName);

    if (apiData.hasError) {
      dispatch(getTaskStatusFailure(apiData.errors));
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(getTaskStatusSuccess(apiData.taskStatus));
  } catch (error) {
    batch(() => {
      dispatch(getTaskStatusFailure(error));
      dispatch(handleErrors(error));
    });
  }
};
